
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function ProductTypesSection() {
  return (
    <div className="container mx-auto px-4 py-12 bg-gray-50">
      <h2 className="text-3xl font-bold text-center mb-8">Discover Our Secondary Glazing Solutions</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <Link to="/vertical-sliding-units-glazing" className="group">
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h3 className="text-xl font-semibold mb-2 text-primary group-hover:underline">Vertical Sliding Units</h3>
            <p className="text-gray-600">Perfect for traditional sash windows in period properties.</p>
          </div>
        </Link>
        <Link to="/sliding-units-glazing" className="group">
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h3 className="text-xl font-semibold mb-2 text-primary group-hover:underline">Horizontal Sliding Units</h3>
            <p className="text-gray-600">Ideal for casement windows and larger openings.</p>
          </div>
        </Link>
        <Link to="/fixed-units-glazing" className="group">
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h3 className="text-xl font-semibold mb-2 text-primary group-hover:underline">Fixed Units</h3>
            <p className="text-gray-600">Maximum insulation for windows that don't require opening.</p>
          </div>
        </Link>
      </div>
      <div className="text-center mt-8">
        <Link to="/secondary-glazing">
          <Button variant="outline" className="mt-4">View All Secondary Glazing Options</Button>
        </Link>
      </div>
    </div>
  );
}
